"use strict";

var _defineProperty = require("/Users/tapanshah/aenetworks/aetn.editorials.washington/node_modules/@babel/runtime/helpers/defineProperty");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.socialType = socialType;
exports.socialLinkType = void 0;

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var socialLinkType = (0, _propTypes.shape)({
  url: _propTypes.string.isRequired,
  icon: _propTypes.string.isRequired
});
exports.socialLinkType = socialLinkType;

function socialType(props, propName, componentName) {
  var keys = (0, _keys["default"])(props.socialMap);
  return (0, _propTypes.checkPropTypes)(_defineProperty({}, propName, (0, _propTypes.oneOf)(keys)), props, propName, componentName);
}